import React from 'react';
import PropTypes from 'prop-types';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import styled from 'styled-components';
import * as STYLE_CONSTANTS from '../../styles/styleConstants';

export const AlpineContainer = (props) => {
  // const isXS = (theme) => theme.breakpoints.is('xs');
  // const queries = {isXS: isXS(myTheme)};
  // console.log('QQQ', queries);

  //console.log ('alpinecontainer props');
  //console.log(props);

  return (
    <StyledGridContainer
      // queries={queries}
      id="ipermit-grid-container"
      className={`${props.hideDefaultGrid ? '' : 'ag-theme-alpine'}${props.className ? ` ${props.className}` : ''}`}
      //@ts-ignore
      hidedefaultgrid={props?.hideDefaultGrid}
      isTabOffset={props?.isTabOffset}
    >
      {props.children}
    </StyledGridContainer>
  );
};


const StyledGridContainer = styled.div`
  //height: calc(100vh - 100px);
  border-bottom: 2px solid #f4f7fd;
  width: 100%;
  height: calc(100vh -  ${(props)=>STYLE_CONSTANTS.HEIGHT.NAVBAR({isXS: false})} - 50px - 20px - ${(props)=>STYLE_CONSTANTS.HEIGHT.PAGINATOR(props.queries)} - ${(props)=>STYLE_CONSTANTS.HEIGHT.TABOFFSET({isTabOffset: props?.isTabOffset})} - var(--grid-extra-offset, 0px)); // window height - [navbar] - [header] -[padding] - [paginator] - [tabOffset] - [extra]
`;
// `--grid-extra-offset` is for a page that puts content of its own above the grid, which the
// formula above cannot know about: the AI dashboard sets it to its summary cards' height.

AlpineContainer.propTypes = {
  hideDefaultGrid: PropTypes.bool,
  className: PropTypes.string,
};
AlpineContainer.defaultProps = {
  hideDefaultGrid: false,
  className: undefined,
};
